import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SharedModule } from '../shared/shared.module';
import { OemService } from './oem.service';
import { TradersChangePasswordSentComponent } from './traders-change-password-sent/traders-change-password-sent.component';
import { TradersForgotPasswordComponent } from './traders-forgot-password/traders-forgot-password.component';
import { TradersInputComponent } from './traders-input/traders-input.component';
import { TradersLoginComponent } from './traders-login/traders-login.component';
import { TradersOemHeaderComponent } from './traders-oem-header/traders-oem-header.component';
import { TradersOemLoginMessageComponent } from './traders-oem-login-message/traders-oem-login-message.component';
import { TradersOemRegisterMessageComponent } from './traders-oem-register-message/traders-oem-register-message.component';
import { TradersPasswordInputComponent } from './traders-password-input/traders-password-input.component';
import { TradersRegisterResendComponent } from './traders-register-resend/traders-register-resend.component';
import { TradersRegisterSendComponent } from './traders-register-send/traders-register-send.component';
import { TradersRegisterComponent } from './traders-register/traders-register.component';
import { TradersResetPasswordComponent } from './traders-reset-password/traders-reset-password.component';
import { TradersUnblockComponent } from './traders-unblock/traders-unblock.component';
import { TradersComponent } from './traders/traders.component';

@NgModule({
  declarations: [
    TradersComponent,
    TradersLoginComponent,
    TradersRegisterComponent,
    TradersUnblockComponent,
    TradersRegisterResendComponent,
    TradersRegisterSendComponent,
    TradersForgotPasswordComponent,
    TradersResetPasswordComponent,
    TradersChangePasswordSentComponent,
    TradersInputComponent,
    TradersPasswordInputComponent,
    TradersOemHeaderComponent,
    TradersOemRegisterMessageComponent,
    TradersOemLoginMessageComponent,
  ],
  imports: [
    CommonModule,
    NgxSpinnerModule,
    FormsModule,
    RouterModule,
    SharedModule,
  ],
  exports: [
    TradersResetPasswordComponent,
    TradersComponent,
    TradersRegisterResendComponent,
    TradersRegisterSendComponent,
    TradersUnblockComponent,
    TradersChangePasswordSentComponent,
  ],
  providers: [OemService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TradersModule {}
